import { ApolloProvider } from '@apollo/react-hooks';
import type React from 'react';
import { ModalStackContextProvider } from '@/components/modal/Modal';
import { PurchaseCTAProvider } from '@/components/PurchaseCTA';
import { UserProfileServiceProvider } from '@/components/UserProfileServiceProvider';
import AppProvider from './AppProvider';
import CourseNavToggleProvider from './course-nav-toggle-provider';

export default function Providers({
  mainContentRef,
  children,
}: {
  mainContentRef: React.RefObject<HTMLElement | null>;
  children: (error: unknown) => React.ReactNode;
}) {
  return (
    <AppProvider mainContentRef={mainContentRef}>
      {(apiClient, error, userID) =>
        apiClient ? (
          <ApolloProvider client={apiClient}>
            <UserProfileServiceProvider userId={userID || ''}>
              <PurchaseCTAProvider>
                <ModalStackContextProvider>
                  <CourseNavToggleProvider>
                    {children(error)}
                  </CourseNavToggleProvider>
                </ModalStackContextProvider>
              </PurchaseCTAProvider>
            </UserProfileServiceProvider>
          </ApolloProvider>
        ) : (
          children(error)
        )
      }
    </AppProvider>
  );
}
